const formDataSchema = {
    feilds: [
        {
            id: 1,
            name: 'tariff',
            title: 'Tariff',
            text2: 'Tariff:',
            visible: true,
            element: 'select2',
            required: true,
            input_type: 'select',
            placeholder: 'Tariff',
            icon: 'user',
            rules: [
                {
                    // test: (value) => {
                    //     //return (value !== null && value.length > 0);
                    //     return true;
                    // },
                    // message: 'Please Select unit'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'd-flex pr-0'
        }, {
            id: 2,
            name: 'search_key',
            title: 'Search',
            text2: 'Search:',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'text',
            placeholder: 'Search',
            icon: 'user',
            rules: [
                {
                    // test: (value) => {
                    //     return (value !== null && value.length > 0);
                    // },
                    // message: 'Please Select Role'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: 'col-6 p-0'
        }
    ]
}

export default formDataSchema;